import { Component, Input } from '@angular/core';
import { DropdownItem } from 'sv-chemistry-ng-lib';
import { UserInfoService } from './core/services/user-info.service';
import { User } from './models/user';
import { Store } from './models/store';
import { Router } from '@angular/router';
import { Retailer } from './models/Retailer';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
  
})
export class AppComponent {
  activeTab = 0;
  userNotFound = false;
  isSessionTimeOut = false;

  title = 'one-pass-ordering-portal';

  selectedRetailCompany : DropdownItem;

  dropdownItems: RetailCompanyDropdown[] =[];
  currentUser : User = null;

  constructor(private _userService: UserInfoService , private router : Router){}

  ngOnInit(){
//    let currentUser : User;
    this._userService.getUserInformation().subscribe(user => {
      this._userService.setCurrentUser(user);
//console.log("currentUser.retailers: " + user.retailers);
      if(user.retailers && user.retailers.length >0) {
        user.retailers.forEach(retailCompany => {
          let retailCompanyDropDownItem : RetailCompanyDropdown = new RetailCompanyDropdown()
          retailCompanyDropDownItem.data = retailCompany;
          retailCompanyDropDownItem.name = retailCompany.retailerName;
          this.dropdownItems.push(retailCompanyDropDownItem);
          this.selectedRetailCompany = this.dropdownItems[0];
        });   
      }
      if(this.selectedRetailCompany) {
        this._userService.setSelectedRetialCompany(this.selectedRetailCompany.data);
      }
      this.currentUser = this._userService.getCurrentUser();
    },
    error => {
      if(error.status == 401 || error.status == 400) {
        this.userNotFound = true;
      }
    });
  }

  orderTableDetails(){
    if(this._userService.isTimeout()) {
      this.userNotFound = true;
      this.isSessionTimeOut = true;
    }
    console.log('order');
  }
  
  catalogTableDetails(){
    if(this._userService.isTimeout()) {
      this.userNotFound = true;
      this.isSessionTimeOut = true;
    }
    console.log('catalog');
  }

  dropDownChanged() {
    this._userService.setSelectedRetialCompany(this.selectedRetailCompany.data);
  }

  returnToLogin() {
    window.location.href = environment.guardLoginUrl;
  }
}

export class RetailCompanyDropdown implements DropdownItem {
  name: string;
  data: Retailer;
}

